export const GRAY = `#efeff0`;
